/** Overall banner, derived from the rows and the freshness of the data. */
export enum BannerState {
  Loading = 'loading',
  /** The service answered and reported nothing to monitor — distinct from a request still in flight. */
  Empty = 'empty',
  Available = 'available',
  Partial = 'partial',
  Major = 'major',
  Delayed = 'delayed',
  Offline = 'offline',
  /** The API answered but refused the internal view for this deployment — not a network problem. */
  AuthError = 'auth-error',
}
